import styled from 'styled-components';
import { rotate } from 'ui/theme/keyframes';

export const Spinner = styled.span`
  animation: ${({ centered }) => rotate(centered)} 1.5s linear infinite;
  border: solid 3px #eee;
  border-bottom-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  content: '';
  height: ${({ size = '40px' }) => size};
  opacity: inherit;
  transform-origin: center;
  width: ${({ size = '40px' }) => size};
  will-change: transform;
  ${({ centered }) =>
    centered &&
    `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  `}
  ${({ hidden }) => hidden && `display: none;`}
`;
